export enum PeriodicityType {
    DATE = 'date',
    INTERVAL = 'intervalle',
}